export function tabShowCustomerColumn (participants) {
  return (Array.isArray(participants) ? participants : []).length > 1
}
